import { useEffect, useState } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { searchMovies } from "@/services/movieService";

export function useDebounce(value, delay = 300) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return v;
}

export function useSearch(q, { genre, type, sort } = {}) {
  const query = (q || "").trim();
  return useInfiniteQuery({
    queryKey: ["movies", query, genre || "", type || "", sort || "popular"],
    queryFn: ({ pageParam, signal }) => searchMovies({ q: query, page: pageParam, genre, type, sort, signal }),
    initialPageParam: 1,
    getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    placeholderData: (prev) => prev,
    staleTime: 45 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
